import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit {

  newsList = [
      {
      date: '2025-9',
      list: [
        `Xuehai Zhou\’s paper, “3D skeletonization and phenotyping for soybean root system architecture using a bio-inspired algorithm,” has been published in Computers and Electronics in Agriculture.`
      ]
    },
    {
      date: '2025-9',
      list: [
        `Alice Liang\’s project, titled “Building a Diverse Plant Dataset for Modelling Plant–Environment Interactions through Visual Simulations,” won 1st place in the Undergraduate Student Research Awards (USRA).`
      ]
    },
        {
      date: '2025-7',
      list: [
        `Mohamed\’s paper, “Predictive Modeling, Pattern Recognition, and Spatiotemporal Representations of Plant Growth in Simulated and Controlled Environments: A Comprehensive Review,” has been published in Plant Phenomics.`
      ]
    },
    {
      date: '2025-7',
      list: [
        `Yu Tian was honoured with two awards at ASABE - American Society of Agricultural and Biological Engineers 2025 for the paper "Soybean-PCMAE: Perturbation Consistent Masked Autoencoders for Few-shot Segmentation of 3D Soybean Point Clouds": 
        \n 🏆 Information Technology, Sensors, and Control Systems (ITSC) Technical Community Paper Award and 
        \n 🏆 Outstanding Student Paper Award from the Association of Overseas Chinese Agricultural, Biological, and Food Engineers (AOC).`
      ]
    },
    {
      date: '2025-4',
      list: [
        `Xuehai Zhou has been awarded the FRQNT Doctoral Research Scholarship, totaling $91,667 over four years. Congratulation!`
      ]
    },
    {
      date: '2024-11',
      list: [
        `Dr. Sun received McCAIS Interdisciplinary Research Development Award 2024. Congratulations!`
      ]
    },
    {
      date: '2024-10',
      list: [
        `Zhouzhou\'s Paper \"Characterising vibration patterns of winter jujube trees to optimise automated fruit harvesting\" has been published on Biosystems Engineering.`
      ]
    },
    {
      date: '2024-9',
      list: [
        'We are excited to welcome two new PhD students to our lab this Fall semester, 2024: Liuyi He and Weitong Wang. Welcome aboard!'
      ]
    },
    {
      date: '2024-9',
      list: [
        'Starting this Fall semester, 2024, we are pleased to welcome two new Master\'s students to our lab: Nazia Hossain and Sabid Hasan. Welcome!'
      ]
    },
    {
      date: '2024-7',
      list: [
        'Welcome, Yu Tian, to our team! Your expertise in point cloud analysis and deep learning for plant phenotyping will greatly enhance our research. We look forward to your innovative contributions and fresh perspectives!'
      ]
    },
    {
      date: '2024-6',
      list: [
        'Congratulations! Xuehai\'s paper "Advancing tracking-by-detection with MultiMap: Towards occlusion-resilient online multiclass strawberry counting" has been accepted by Expert Systems with Applications. Well done!'
      ]
    },
    {
      date: '2024-4',
      list: [
        'Zhouzhou\'s paper titled "A novel jujube tree trunk and branch salient object detection method for catch-and-shake robotic visual perception" has been accepted by Expert Systems with Application. Congratulations!'
      ]
    },
    {
      date: '2023-12',
      list: [
        'Welcome, Zhouzhou, to our team; your passion for computer vision, deep learning, and agricultural robotics promises to bring fresh perspectives to our fruit harvesting projects!'
      ]
    },
    {
      date: '2023-11',
      list: [
        'Welcome, Yixue, to our lab, where your expertise in computer vision and UAV remote sensing for plant phenotyping will surely inspire us all!'
      ]
    },
    {
      date: '2023-7',
      list: [
        'Liyi\'s paper titled "Eff-3DPSeg: 3D organ-level plant shoot segmentation using annotation-efficient deep learning" has been accepted by Plant Phenomics. Congratulations!'
      ]
    },
    {
      date: '2023-6',
      list: [
        'Welcome Dr. Rui Kang to our lab! We look forward to his new frontiers in hyperspectral imaging and agricultural robotics.'
      ]
    },
    {
      date: '2023-5',
      list: [
        'Xuehai’s paper “A dynamic object counting method for strawberry fruits using vision transformer networks and kalman filter tracking” was chosen for an ITSC Technical Community Meeting Paper Award in ASABE 2023. Congratulations!',
        'Yu’s paper "PEAMATL: A strategy for developing near-infrared spectral prediction models under domain shift using self-supervised transfer learning" has been published by IEEE Transactions on Instrumentation and Measurement. Congratulations!'
      ]
    },
    {
      date: '2023-1',
      list: [
        'Welcome Xuehai Zhou and Kunwei Sun to our lab! We look forward to their contributions and success in their research endeavors.'
      ]
    },
    {
      date: '2022-12',
      list: [
        'Mohamed Debbagh joins our lab as a PhD student (co-supervise with Prof. Mark Lefsrud). Welcome new member!',
        'Yu’s paper "Rapid determination of the roasting degree of cocoa beans by extreme learning machine (ELM)-based imaging analysis" is accepted by the Journal of Agriculture and Food Research. Congratulations!',
        'Yu’s paper "An improved DEtection TRansformer deep learning network for multi-size peach detection using an RGB-D camera in orchards" is accepted by the journal of Intelligent Data Analysis. Congratulations!'
      ]
    },
    {
      date: '2022-08',
      list: [
        'Xintong received Clifford C.F. Wong Fellowship for the 2022-2023 academic year (estimated value $20,000).  Congratulations!',
        'Liyi received the Oral Presentation Award within Information Technology, Sensors, and Control (ITSC) Systems technical community for his paper entitled, “An annotation-efficient 3D deep learning network for plant shoot segmentation using point clouds” in ASABE 2022.  Congratulations!',
        'Yu’s paper "Predictions of multiple food quality parameters using near-infrared spectroscopy with a novel multi-task genetic programming approach" is accepted by the journal of Food Control. Congratulations!'
      ]
    }
  ]

  constructor() { }

  ngOnInit(): void { }

}
